import { render, staticRenderFns } from "./VSectionField.vue?vue&type=template&id=0b02fdc9&"
import script from "./VSectionField.vue?vue&type=script&lang=js&"
export * from "./VSectionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports